import {forwardRef} from "react";
import {BaseSelect} from "./BaseSelect";
import {
    white,
    primaryPurple,
    lemonMilk,
    black,
    secondaryGreenLight,
    greenLightBg,
    primaryPink,
    secondaryGreenMedium
} from "../../Theme";
import caretDownIcon from "../../resources/images/ic-caretDownBlack.svg";

export const FilterSelect = forwardRef(function FilterSelect(props, ref) {
    const {options, ...otherProps} = props;

    return (
        <BaseSelect
            options={options}
            styles={{
                container: (baseStyles) => ({
                    ...baseStyles,
                    width: "100%",
                }),
                control: (baseStyles, { isFocused }) => ({
                    ...baseStyles,
                    width: "100%",
                    padding: "6px 32px 6px 12px",
                    borderRadius: "16px",
                    color: primaryPurple,
                    fontFamily: lemonMilk,
                    fontSize: "15px",
                    backgroundImage: `url(${caretDownIcon})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 8px top 50%",
                    backgroundSize: "20px",
                    backgroundColor: greenLightBg,
                    border: isFocused
                        ? `1px solid ${primaryPink}`
                        : `1px solid ${primaryPurple}`,
                    textAlign: "left",
                    cursor: "pointer",
                    minHeight: "32px",
                    boxShadow: isFocused
                        ? `0 0 0 1px ${primaryPink}`
                        : "none",
                }),
                placeholder: (baseStyles) => ({
                    ...baseStyles,
                    color: primaryPurple,
                    opacity: ".3",
                }),
                input: (baseStyles) => ({
                    ...baseStyles
                }),
                valueContainer: (baseStyles) => ({
                    ...baseStyles,
                    gap: "10px",
                }),
                menu: (baseStyles, {options}) => ({
                    ...baseStyles,
                    background: white,
                    marginTop: "4px",
                    overflow: "hidden",
                    zIndex: "100",
                    border: "1px solid #D5DCD1",
                }),
                menuList: (baseStyles) => ({
                    ...baseStyles,
                    maxHeight: window.screen.height - 250,
                }),
                option: (baseStyles, { isSelected, isFocused }) => ({
                    ...baseStyles,
                    padding: "12px",
                    color: black,
                    fontFamily: lemonMilk,
                    fontSize: "15px",
                    background: isSelected ? secondaryGreenLight : white,
                    cursor: "pointer",
                    "&:hover": {
                        background: secondaryGreenLight,
                    },
                    border: isFocused
                        ? `2px solid ${secondaryGreenMedium}`
                        : "2px solid transparent",
                }),
                noOptionsMessage: () => ({
                    color: black,
                    textAlign: "center",
                    fontFamily: lemonMilk,
                    fontSize: "15px",
                    padding: "20px",
                }),
                singleValue: (baseStyles) => ({
                    ...baseStyles,
                }),
                clearIndicator: (baseStyles) => ({
                    ...baseStyles
                })
            }}
            {...otherProps}
        />
    )
})